import ApiService from './ApiService'


const logout = (body) => {
    return ApiService.post(`/Usuario/Logout`, body)
};

export default {
    logout
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/services/logout.js